import React, { lazy } from 'react';
// Fallback component when the dynamic import fails
const FallbackComponent = () => {
  return /*#__PURE__*/React.createElement('div', null, 'Component could not be loaded');
};
export const getGeneratedComponent = function (code) {
  if (code === void 0) {
    code = '';
  }
  // If no code is provided, return a component that renders the fallback
  if (!code || code.trim() === '') {
    return /*#__PURE__*/lazy(async () => ({
      default: FallbackComponent
    }));
  }
  const blob = new Blob([code], {
    type: 'text/javascript'
  });
  const blobUrl = URL.createObjectURL(blob);
  const loadComponent = async () => {
    try {
      const module = await import(/* webpackIgnore: true */blobUrl);

      // Check if the module has a default export that's a valid component
      if (module && typeof module.default === 'function') {
        return module;
      } else {
        console.warn('getGeneratedComponent: Module does not have a valid default export', {
          module,
          code
        });
        return {
          default: FallbackComponent
        };
      }
    } catch (err) {
      console.error('getGeneratedComponent error ', {
        err,
        code
      });
      // Return fallback component instead of throwing
      return {
        default: FallbackComponent
      };
    } finally {
      // Clean up the blob URL to prevent memory leaks
      URL.revokeObjectURL(blobUrl);
    }
  };
  return /*#__PURE__*/lazy(loadComponent);
};
//# sourceMappingURL=getGeneratedComponent.js.map